import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import OrganizationSendgridTemplateAppResource from './OrganizationSendgridTemplateAppResource';

class MilestonesSendgridTemplateAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'milestones-sendgrid-template';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'milestones/sendgrid/templates';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'updated_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'templateId',
            'templateName',
        ];
    }


    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            organizationSendgridTemplates: OrganizationSendgridTemplateAppResource,
        };
    }


    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            organizationSendgridTemplates: 'template_id',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return [
        ];
    }

}

export default MilestonesSendgridTemplateAppResource;
